import { fetchData } from '@/utils/fetch'
import { toReject } from './util'

export const retrieveFactoryProductList = (data, options) => {
  return fetchData('/appb/b2b/product/supplier/productV2', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const retrieveFactoryInfo = toReject((factoryId) => {
  return fetchData(`/appb/b2b/supplier/get?sellerOpenId=${factoryId}`)
})

export const retrieveFactoryDetail = toReject((factoryId) => {
  return fetchData(`/appb/b2b/supplier/detail?sellerOpenId=${factoryId}`)
})

export const retrieveFactoryTopProduct = toReject(({
  sellerOpenId,
  topN
}) => {
  return fetchData(`/appb/b2b/product/supplier/product/top?sellerOpenId=${sellerOpenId}&topN=${topN}`)
})
